import {Status} from '../../helpers/mergeability-status'
import {MergeAction} from '../../types'
import {useSidebarMergeData} from './use-sidebar-merge-data'
import {SidebarQueuedState} from './SidebarQueuedState'
import {SidebarDisableAutoMerge} from './SidebarDisableAutoMerge'
import {SidebarEnqueueButton} from './SidebarEnqueueButton'
import {SidebarEnableAutoMergeButton} from './SidebarEnableAutoMergeButton'
import {SidebarMergeButton} from './SidebarMergeButton'

export function SidebarMergeWhenReadyButton() {
  const {validatedMergeData, mergeBoxPullRequest, status} = useSidebarMergeData()

  if (!validatedMergeData || !mergeBoxPullRequest) return null

  const {isInMergeQueue, mergeQueueEntry, autoMergeRequest, viewerCanEnableAutoMerge, viewerMergeActions} =
    mergeBoxPullRequest
  const isMergeQueueEnabled =
    viewerMergeActions.find(action => action.name === MergeAction.MERGE_QUEUE)?.allowableStatus === 'ALLOWED'
  const isMergeable = status === Status.Mergeable

  // Already queued — surface the queue position and the option to remove it.
  if (isInMergeQueue && mergeQueueEntry) return <SidebarQueuedState />
  // Auto-merge is already enabled — offer to disable it.
  if (autoMergeRequest) return <SidebarDisableAutoMerge />

  // Merge-queue repos always offer "Merge when ready": it queues the pull request now (when
  // it's mergeable) or enables auto-merge so it queues once its requirements pass. The button
  // itself reflects whether it can be actioned yet, mirroring the docked merge panel.
  if (isMergeQueueEnabled) return <SidebarEnqueueButton />

  // Direct-merge repos that aren't mergeable yet: enable auto-merge so the pull request
  // merges automatically once its checks pass and approvals land.
  if (!isMergeable && viewerCanEnableAutoMerge) return <SidebarEnableAutoMergeButton />

  // Fallback (mergeable now, or auto-merge isn't available): always surface the merge status
  // button so the merge controls remain visible and reachable from the sidebar.
  return <SidebarMergeButton />
}
